'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
require('./constants-0cf35288.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
var arrowLeftChevron = require('./arrow-left-chevron-4cbe9905.js');
var arrowRightChevron = require('./arrow-right-chevron-07b97bed.js');
var lastPage = require('./last-page-124ad571.js');
require('./pill-80fa7aa7.js');
require('./form-field-568b9a9c.js');
require('./asterisk-436ee6b3.js');
require('./field-label-4ed9b7f8.js');
require('./field-hint-cc714695.js');
require('./messages-f8f39369.js');
require('./loader-f28c8bde.js');
var select = require('./select-6c9d108c.js');
var selectItem = require('./select-item-7fd13c43.js');
require('./select-title-65885e9f.js');
require('./styles-a9f2fe66.js');
require('./calendar-date.styles-9072cd1e.js');
require('./styles-20009c57.js');
require('./index.esm-c41adfff.js');
require('./fa-icon-d6ca067a.js');
require('./field.styles-a36bbd7b.js');
require('./styles-424066e0.js');
require('./overlay-878554b6.js');
require('./paper-e6cfe656.js');
require('./style-d0a65e48.js');
require('./styles-558f9987.js');
require('./native-select.styles-3602a739.js');
require('./select-wrapper.styles-0104a777.js');
require('./device.context-f96381a3.js');
require('./mobile-detect-2421ba00.js');
require('./styles-38df6401.js');
require('./styles-f287cb5d.js');
require('./status-indicator-f5477803.js');
require('./styles-6fa8f6cf.js');
require('./text-break-b3fca248.js');
var tooltip = require('./tooltip-8d9d80ea.js');

var LimitSelector = function (_a) {
    var limits = _a.limits, limit = _a.limit, setLimit = _a.setLimit;
    var onChangeLimitHandler = React.useCallback(function (event) {
        setLimit(Number(event.target.value));
    }, [limit]);
    return (React__default.createElement(select.Select, { value: limit, name: "limit", onChange: onChangeLimitHandler, "data-testid": "select-limit", type: "pagination" }, limits.map(function (item) { return (React__default.createElement(selectItem.SelectItem, { key: item, value: item, renderedValue: item.toString(), type: "pagination" })); })));
};

var FIRST_PAGE = 1;
var StyledInfo = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  white-space: pre;\n\n  .highlighted {\n    font-weight: 500;\n  }\n\n  .MuiInputBase-root {\n     height: 32px;\n     border-width: 0;\n     background-color: ", ";\n\n     label {\n       margin-left: 4px;\n     }\n   }\n"], ["\n  display: flex;\n  align-items: center;\n  white-space: pre;\n\n  .highlighted {\n    font-weight: 500;\n  }\n\n  .MuiInputBase-root {\n     height: 32px;\n     border-width: 0;\n     background-color: ", ";\n\n     label {\n       margin-left: 4px;\n     }\n   }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyLight;
});
var Info = function (_a) {
    var total = _a.total, limits = _a.limits, limit = _a.limit, setLimit = _a.setLimit, offset = _a.offset, labels = _a.labels;
    var showingFrom = offset + 1;
    var showingTo = Math.min(showingFrom + limit - 1, total);
    var isFirstPage = Math.ceil(showingFrom / limit) === FIRST_PAGE;
    return (React__default.createElement(StyledInfo, null, labels.showing + " ",
        React__default.createElement("b", { className: "highlighted", "data-testid": "from" }, total && showingFrom + " - " + (!isFirstPage ? showingTo : '')),
        isFirstPage && !!total && (React__default.createElement(LimitSelector, { limits: limits, limit: limit, setLimit: setLimit, "data-testid": "limit" })), " " + labels.of + " ",
        React__default.createElement("span", { "data-testid": "to" }, total), " " + labels.items));
};
var templateObject_1;

var FIRST_PAGE_INDEX = 1;

var StyledButton = styled__default.button(templateObject_1$1 || (templateObject_1$1 = tslib_es6.__makeTemplateObject(["\n  margin: 0 4px 0 0;\n  width: 24px;\n  height: 24px;\n  border-width: 0;\n  border-radius: 50%;\n  padding: 0;\n  background-color: ", ";\n  color: ", ";\n  font: 14px/22px ", ";\n  transition: background-color .15s ease-out;\n\n  &:disabled {\n    cursor: not-allowed;\n    svg {\n      color: ", ";\n    }\n  }\n\n  &:not(:disabled) {\n    cursor: pointer;\n\n    &:hover {\n      background-color: ", ";\n\n      &.selected {\n        background-color: ", ";\n      }\n    }\n  }\n\n  &.selected {\n    background-color: ", ";\n    color: ", ";\n  }\n\n  svg {\n    color: ", ";\n  }\n"], ["\n  margin: 0 4px 0 0;\n  width: 24px;\n  height: 24px;\n  border-width: 0;\n  border-radius: 50%;\n  padding: 0;\n  background-color: ", ";\n  color: ", ";\n  font: 14px/22px ", ";\n  transition: background-color .15s ease-out;\n\n  &:disabled {\n    cursor: not-allowed;\n    svg {\n      color: ", ";\n    }\n  }\n\n  &:not(:disabled) {\n    cursor: pointer;\n\n    &:hover {\n      background-color: ", ";\n\n      &.selected {\n        background-color: ", ";\n      }\n    }\n  }\n\n  &.selected {\n    background-color: ", ";\n    color: ", ";\n  }\n\n  svg {\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.transparent;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyMedium;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyLight;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primaryHover;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.primary;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.universal.white;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
});
var RelativeButton = function (_a) {
    var disabled = _a.disabled, setPage = _a.setPage, children = _a.children;
    return (React__default.createElement(StyledButton, { type: "button", className: "page-btn", disabled: disabled, onClick: setPage }, children));
};
var templateObject_1$1;

var StyledEllipsis = styled__default.span(templateObject_1$2 || (templateObject_1$2 = tslib_es6.__makeTemplateObject(["\n  margin-right: 4px;\n"], ["\n  margin-right: 4px;\n"])));
var ellipsis = React__default.createElement(StyledEllipsis, { className: "ellipsis" }, "\u2026");
var isOnlyOnePage = function (buttons) { return buttons.length === 1; };
var NumberedButton = function (_a) {
    var index = _a.index, page = _a.page, totalPages = _a.totalPages, buttons = _a.buttons, setPage = _a.setPage;
    var isSelected = index === page;
    var noEllipsis = isOnlyOnePage(buttons);
    var isEllipsisBefore = !noEllipsis && index === totalPages && !buttons[buttons.length - 2];
    var isEllipsisAfter = !noEllipsis && index === FIRST_PAGE_INDEX && !buttons[1];
    var button = (React__default.createElement(StyledButton, { type: "button", className: "page-btn " + (isSelected ? 'selected' : ''), onClick: setPage(index) }, index));
    return (React__default.createElement(React__default.Fragment, null,
        isEllipsisBefore && ellipsis,
        button,
        isEllipsisAfter && ellipsis));
};
var templateObject_1$2;

var generateMask = function (totalPages, startIndex, totalVisibleButtons) {
    var buttons = Array.from(Array(totalPages).fill(false), function (_item, index) { return !index || index === totalPages - 1; });
    var endIndex = Math.min(startIndex + totalVisibleButtons, totalPages);
    for (var index = Math.max(startIndex, 0); index < endIndex; index += 1) {
        buttons[index] = true;
    }
    return buttons;
};
var getVisibleButtons = function (currentPage, totalPages, totalVisibleButtons) {
    if (currentPage < totalVisibleButtons - 1) {
        return generateMask(totalPages, 0, totalVisibleButtons);
    }
    if (currentPage > totalPages - totalVisibleButtons) {
        return generateMask(totalPages, totalPages - totalVisibleButtons, totalVisibleButtons);
    }
    return generateMask(totalPages, currentPage - Math.ceil(totalVisibleButtons / 2), totalVisibleButtons);
};
var AbsoluteButtons = function (_a) {
    var page = _a.page, totalPages = _a.totalPages, totalVisibleButtons = _a.totalVisibleButtons, setPage = _a.setPage;
    var visibleButtons = getVisibleButtons(page, totalPages, totalVisibleButtons);
    return (React__default.createElement(React__default.Fragment, null, visibleButtons.map(function (button, index) {
        var label = index + 1;
        return (React__default.createElement(React.Fragment, { key: label }, button
            ? (React__default.createElement(NumberedButton, { index: label, page: page, totalPages: totalPages, buttons: visibleButtons, setPage: setPage })) : null));
    })));
};

var Controls = function (_a) {
    var page = _a.page, totalPages = _a.totalPages, totalVisibleButtons = _a.totalVisibleButtons, setPage = _a.setPage, labels = _a.labels;
    var isEmpty = totalPages === 0;
    var isFirstPage = page === FIRST_PAGE_INDEX || isEmpty;
    var isLastPage = page === totalPages || isEmpty;
    var setPageHandler = React.useCallback(function (index) { return function () { return setPage(index); }; }, [setPage]);
    return (React__default.createElement("div", null,
        React__default.createElement(tooltip.Tooltip, { text: !isFirstPage && labels.firstPage, placement: "bottom" },
            React__default.createElement(RelativeButton, { disabled: isFirstPage, setPage: setPageHandler(FIRST_PAGE_INDEX) },
                React__default.createElement(lastPage.FirstPage, { size: "xs" }))),
        React__default.createElement(RelativeButton, { disabled: isFirstPage, setPage: setPageHandler(page - 1) },
            React__default.createElement(arrowLeftChevron.ArrowLeftChevron, { size: "xs" })),
        React__default.createElement(AbsoluteButtons, { page: page, totalPages: totalPages, totalVisibleButtons: totalVisibleButtons, setPage: setPageHandler }),
        React__default.createElement(RelativeButton, { disabled: isLastPage, setPage: setPageHandler(page + 1) },
            React__default.createElement(arrowRightChevron.ArrowRightChevron, { size: "xs" })),
        React__default.createElement(tooltip.Tooltip, { text: !isLastPage && labels.lastPage, placement: "bottom" },
            React__default.createElement(RelativeButton, { disabled: isLastPage, setPage: setPageHandler(totalPages) },
                React__default.createElement(lastPage.LastPage, { size: "xs" })))));
};

var DEFAULT_LIMITS = [10, 20, 30, 50, 100];
var DEFAULT_VISIBLE_BUTTONS = 3;
var PaginationRow = styled__default.div(templateObject_1$3 || (templateObject_1$3 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 28px;\n  font: 14px/22px ", ";\n  color: ", ";\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  height: 28px;\n  font: 14px/22px ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
});
var Pagination = function (_a) {
    var page = _a.page, setPage = _a.setPage, limit = _a.limit, setLimit = _a.setLimit, offset = _a.offset, total = _a.total, _b = _a.limits, limits = _b === void 0 ? DEFAULT_LIMITS : _b, labels = _a.labels;
    var numberOfPages = Math.ceil(total / limit);
    return (React__default.createElement(PaginationRow, { "data-testid": "pagination" },
        React__default.createElement(Info, { total: total, limits: limits, limit: limit, setLimit: setLimit, offset: offset, labels: labels }),
        React__default.createElement(Controls, { page: page, totalPages: numberOfPages, totalVisibleButtons: DEFAULT_VISIBLE_BUTTONS, setPage: setPage, labels: labels })));
};
var templateObject_1$3;

exports.Pagination = Pagination;
